import { FC } from "react";
import DefaultProductPageSidebarContent from "../sidebar/default/Content";
import classNames from "classnames";
import SidebarSubscriptionBanner from "./SidebarSubscriptionBanner";
import { useAccess } from "@templates/course/hooks/useAccess";

interface Props {
  stickyTop: number;
  className?: string;
}

const ProductStickySidebar: FC<Props> = ({ stickyTop, className }) => {
  const { courseData } = useAccess();
  const {
    product: { is_free: isFree },
  } = courseData || {};

  return (
    <div
      className={classNames(
        "hidden lg:block sticky product-sidebar-sizing xl:pr-4 lg:ml-4 xl:ml-0 w-full z-40",
        className
      )}
      style={{ top: stickyTop }}
    >
      <DefaultProductPageSidebarContent />
      <SidebarSubscriptionBanner isFree={isFree} />
    </div>
  );
};

export default ProductStickySidebar;
